import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { EventForm } from '../../../_models/event-form.model';
import { CreateEventFormStore } from '../../_services/create-event-form-store.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'submit-step-create-event',
  standalone: false,
  templateUrl: './submit-step-create-event.component.html',
  styleUrl: './submit-step-create-event.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,

})
export class SubmitStepCreateEventComponent {
  public formGroup = input.required<FormGroup<EventForm>>();

  public eventFormStore = inject(CreateEventFormStore);

  public streappEvent = this.eventFormStore.streappEvent;

  public authService = inject(AuthService);

  public linkedEvent = computed(() => !!this.eventFormStore.streappEvent().linkedToMainStreappID);

}
